export default {
  LIST_NETWORKS: [
    "Facebook",
    "Twitter",
    "Telegram",
    "LinkedIn",
    "Youtube",
    "WhatsApp",
    "Reddit",
    "Instagram",
    "Google Plus",
    "WeChat",
  ],
  ICON_CLASSES: [
    "icon-facebook",
    "icon-twitter",
    "icon-telegram",
    "icon-linkedin",
    "icon-youtube3",
    "icon-whatsapp3",
    "icon-reddit3",
    "icon-instagram3",
    "icon-google-plus",
    "icon-wechat",
  ],
  PRODUCT_BASE: "margin",
  MARKETS: ["mgc", "eth", "btc"],
  AIRDROP_LIST_COINS: {
    btc: "BTC",
    eth: "ETH",
    amal: "AMAL",
    all: "ALL",
  },
  MENU: [
    // {
    //   type: "item",
    //   icon: "icon-setting",
    //   name: "Site Setting",
    //   isHasPermission: false,
    //   router: {
    //     name: "site_setting",
    //   },
    // },
    {
      type: "tree",
      icon: "icon-wallet1",
      name: "Wallet",
      isHasPermission: false,
      items: [
        // {
        //   type: "item",
        //   icon: "",
        //   name: "Register ERC-20",
        //   router: {
        //     name: "setting:register-erc20",
        //   },
        // },
        {
          type: "item",
          icon: "",
          name: "Cold Wallet",
          router: {
            name: "ColdWalletSetting",
          },
        },
      ],
    },
    {
      type: "tree",
      icon: "icon-user",
      name: "Users",
      isHasPermission: false,
      items: [
        {
          type: "item",
          icon: "",
          name: "User Information",
          router: {
            name: "users",
          },
        },
        {
          type: "item",
          icon: "",
          name: "User KYC",
          router: {
            name: "kyc",
            subRoutes: "/kyc/detail",
          },
        },
        // {
        //     type: 'item',
        //     icon: '',
        //     name: 'User AMAL Net Ranking',
        //     router: {
        //         name: 'amal_net'
        //     }
        // },
        {
          type: "item",
          icon: "",
          name: "User setting",
          router: {
            name: "user_setting",
          },
        },
        {
          type: "item",
          icon: "",
          name: "User Enable Fee Setting",
          router: {
            name: "user_enable_fee_setting",
          },
        },
        {
          type: "item",
          icon: "",
          name: "Device Management",
          router: {
            name: "device_management",
          },
        },
        // {
        //     type: 'item',
        //     icon: '',
        //     name: 'Group Setting',
        //     router: {
        //         name: 'user_group_setting'
        //     }
        // },
        // {
        //     type: 'item',
        //     icon: '',
        //     name: 'Trading Volume Ranking',
        //     router: {
        //     name: 'tradingVolumeRanking'
        //     }
        // },
      ],
    },
    // {
    //     type: 'tree',
    //     icon: 'icon-referrals',
    //     name: 'Referral',
    //     isHasPermission: false,
    //     items: [
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: 'Referral History',
    //         router: {
    //             name: 'ReferralHistory'
    //         }
    //     },
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: 'Referral Setting',
    //         router: {
    //             name: 'ReferralSetting',
    //         }
    //     },
    //     ]
    // },
    // {
    //     type: 'tree',
    //     icon: 'icon-chart2' ,
    //     isHasPermission: false,
    //     name: 'Sales Point',
    //     items: [
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: 'AMAL Setting',
    //         router: {
    //             name: 'setting:sales-point'
    //         }
    //     },
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: 'AMAL Buy History',
    //         router: {
    //             name: 'buy_history'
    //         }
    //     },
    //     ]
    // },
    {
      type: "tree",
      icon: "icon-exchange-setting",
      name: "Exchange Setting",
      isHasPermission: false,
      items: [
        {
          type: "item",
          icon: "",
          name: "Exchange Balances",
          router: {
            name: "exchange_balance",
          },
        },
        // {
        //     type: 'item',
        //     icon: '',
        //     name: 'Exchange Balances Detail',
        //     router: {
        //         name: 'exchange_balance_detail'
        //     }
        // },
        // {
        //     type: 'item',
        //     icon: '',
        //     name: 'Exchange Profit Detail',
        //     router: {
        //         name: 'profit'
        //     }
        // },
        // {
        //     type: 'item',
        //     icon: '',
        //     name: 'Exchange Balances Detail',
        //     router: {
        //         name: 'exchange_balance_detail'
        //     }
        // },
        {
          type: "item",
          icon: "",
          name: "Transaction Setting",
          router: {
            name: "withdraw_setting",
          },
        },
        {
          type: "item",
          icon: "",
          name: "Trading Setting",
          router: {
            name: "enable_trading_setting",
          },
        },
        {
          type: "item",
          icon: "",
          name: "User Withdrawal Setting",
          router: {
            name: "enable_withdrawal_setting",
          },
        },
        // {
        //     type: 'item',
        //     icon: '',
        //     name: 'Bank Setting',
        //     router: {
        //         name: 'bank_setting'
        //     }
        // },
        {
          type: "item",
          icon: "",
          name: "Fee",
          router: {
            name: "trading_fee_setting",
          },
        },
      ],
    },
    // {
    //   type: 'tree',
    //   icon: 'icon-exchange-setting',
    //   name: 'Circuit Breaker',
    //   isHasPermission: false,
    //   items: [
    //     {
    //       type: 'item',
    //       icon: '',
    //       name: 'Circuit Breaker Setting',
    //       router: {
    //         name: 'circuit_breaker_setting'
    //       }
    //     },
    //   ]
    // },
    {
      type: "tree",
      icon: "icon-transaction",
      name: "Transaction History",
      isHasPermission: false,
      items: [
        // {
        //     type: 'item',
        //     icon: '',
        //     name: 'Deposit USD',
        //     router: {
        //         name: 'Deposit USD'
        //     }
        // },
        // {
        //     type: 'item',
        //     icon: '',
        //     name: 'Withdraw USD',
        //     router: {
        //         name: 'Withdraw USD'
        //     }
        // },
        {
          type: "item",
          icon: "",
          name: "Deposit",
          router: {
            name: "Deposit",
          },
        },
        {
          type: "item",
          icon: "",
          name: "Withdraw",
          router: {
            name: "Withdraw",
          },
        },
      ],
    },
    {
      type: "tree",
      icon: "icon-order",
      name: window.i18n.t("menu.orders.orders"),
      isHasPermission: false,
      items: [
        {
          type: "item",
          icon: "",
          name: window.i18n.t("menu.orders.open_order"),
          router: {
            name: "open_order",
          },
        },
        {
          type: "item",
          icon: "",
          name: window.i18n.t("menu.orders.order_history"),
          router: {
            name: "order_history",
          },
        },
        {
          type: "item",
          icon: "",
          name: window.i18n.t("menu.orders.trade_history"),
          router: {
            name: "trade_history",
          },
        },
      ],
    },
    // {
    //     type: 'tree',
    //     icon: 'icon-megaphone',
    //     name: 'Marketing',
    //     isHasPermission: false,
    //     items: [
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: window.i18n.t('menu.notices'),
    //         router: {
    //             name: 'Notice',
    //             subRoutes: 'notice-edit'
    //         }
    //     },
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: window.i18n.t('menu.email_marketing'),
    //         router: {
    //             name: 'Emails Marketing',
    //             subRoutes: 'emailMarketingEdit,emailMarketingSend'
    //         }
    //     }
    //     ]
    // },
    // {
    //   type: 'tree',
    //   icon: 'icon-airdrop',
    //   name: 'Dividend',
    //   isHasPermission: false,
    //   items: [
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: 'User Unlock Status',
    //         router: {
    //             name: 'AirdropHistory'
    //         }
    //     },
    //     {
    //       type: 'item',
    //       icon: '',
    //       name: 'Dividend Payment History',
    //       router: {
    //         name: 'AirdropPaymentHistory'
    //       }
    //     },
    //     {
    //       type: 'item',
    //       icon: '',
    //       name: 'Dividend Setting',
    //       router: {
    //         name: 'AirdropSetting'
    //       }
    //     },
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: 'Cashback History',
    //         router: {
    //           name: 'CashbackHistory'
    //         }
    //     },
    //     {
    //       type: 'item',
    //       icon: '',
    //       name: 'Manual Payment Dividend',
    //       router: {
    //           name: 'DividendSettingManual'
    //       }
    //     },
    //     {
    //       type: 'item',
    //       icon: '',
    //       name: 'Manual Paid History',
    //       router: {
    //           name: 'ManualDividendHistory'
    //       }
    //     },
    //     {
    //       type: 'item',
    //       icon: '',
    //       name: 'Auto Dividend Setting',
    //       router: {
    //         name: 'AutoDividendSetting'
    //       }
    //     },
    //     {
    //       type: 'item',
    //       icon: '',
    //       name: 'Auto Dividend Paid History',
    //       router: {
    //           name: 'AutoDividendHistory'
    //       }
    //     },
    //   ]
    // },
    // {
    //     type: 'tree',
    //     icon: 'icon-order',
    //     name: 'Margin Orders',
    //     isHasPermission: false,
    //     items: [
    //         {
    //             type: 'item',
    //             icon: '',
    //             name: 'Order',
    //             router: {
    //                 name: 'OrderMargin'
    //             }
    //         },
    //         {
    //             type: 'item',
    //             icon: '',
    //             name: 'Positions',
    //             router: {
    //                 name: 'PositionsMargin'
    //             }
    //         },
    //         {
    //             type: 'item',
    //             icon: '',
    //             name: window.i18n.t('menu.orders.trade_history'),
    //             router: {
    //                 name: 'TradeHistoryMargin'
    //             }
    //         },
    //         // {
    //         //     type: 'item',
    //         //     icon: '',
    //         //     name: window.i18n.t('trade.funding_history'),
    //         //     router: {
    //         //         name: 'FundingHistory'
    //         //     }
    //         // },
    //         // {
    //         //     type: 'item',
    //         //     icon: '',
    //         //     name: 'Trading Setting',
    //         //     router: {
    //         //         name: 'MarginTradingSetting'
    //         //     }
    //         // },
    //         // {
    //         //     type: 'item',
    //         //     icon: '',
    //         //     name: 'Risk Management',
    //         //     router: {
    //         //         name: 'RiskManagement'
    //         //     }
    //         // },
    //         // {
    //         //     type: 'item',
    //         //     icon: '',
    //         //     name: 'Entry Management',
    //         //     router: {
    //         //         name: 'EntryManagement'
    //         //     }
    //         // },
    //         // {
    //         //     type: 'item',
    //         //     icon: '',
    //         //     name: 'Entry Payment Manual',
    //         //     router: {
    //         //         name: 'EntryLeaderboardPaymentManual'
    //         //     }
    //         // },
    //         // {
    //         //     type: 'item',
    //         //     icon: '',
    //         //     name: 'Entry Manual Paid History',
    //         //     router: {
    //         //         name: 'ManualEntryLeaderboardPaidHistory'
    //         //     }
    //         // },
    //     ]
    // },
    //     {
    //     type: 'tree',
    //     icon: 'icon-future-record',
    //     name: 'Futures Records',
    //     isHasPermission: false,
    //     items: [
    //         {
    //             type: 'item',
    //             icon: '',
    //             name: 'Order',
    //             router: {
    //                 name: 'OrderFuturesRecords'
    //             }
    //         },
    //         {
    //             type: 'item',
    //             icon: '',
    //             name: 'Positions',
    //             router: {
    //                 name: 'PositionFuturesRecords'
    //             }
    //         },
    //         {
    //             type: 'item',
    //             icon: '',
    //             name: 'Trades',
    //             router: {
    //                 name: 'TradeFuturesRecords'
    //             }
    //         },
    //     ]
    // },
    // {
    //     type: 'tree',
    //     icon: 'icon-exchange-setting',
    //     name: 'Pass Order to Bitmex',
    //     isHasPermission: false,
    //     items:[
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: 'Mapping Instrument',
    //         router: {
    //         name: 'BitmexMappingInstrument'
    //         }
    //     },
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: 'Traced Account',
    //         router: {
    //         name: 'TracedAccount'
    //         }
    //     },
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: 'Bitmex Account',
    //         router: {
    //         name: 'BitmexAccount'
    //         }
    //     },
    //     {
    //         type: 'item',
    //         icon: '',
    //         name: 'Mapping Order',
    //         router: {
    //         name: 'MappingOrder'
    //         }
    //     }
    //     ],
    // },
    // {
    //     type: 'item',
    //     icon: 'icon-setting',
    //     name: 'Instruments',
    //     isHasPermission: false,
    //     router: {
    //         name: 'Instruments'
    //     },
    // }
    // {
    //   type: "item",
    //   icon: "icon-setting",
    //   name: "Instruments Futures",
    //   isHasPermission: false,
    //   router: {
    //     name: "Instruments Futures",
    //   },
    // },
    // {
    //   type: "item",
    //   icon: "icon-setting",
    //   name: "Reward Center",
    //   isHasPermission: false,
    //   router: {
    //     name: "Reward Center",
    //   },
    // },
  ],
  ROLE_SUPER_ADMIN: "Super Admin",
  PRODUCT_BASE: "margin",
  USER_INFORMATION_TYPE: ["all", "normal", "bot"],
  USER_INFORMATION_STATUS: ["all", "inactive", "active"],
  IS_TESTER_STATUS: ["inactive", "active", "waiting"],
  MAX_LENGTH_INPUT: 190,
  LIST_COIN: ["ada", "bch", "btc", "eos", "eth", "ltc", "xrp"],

  ACTIVE: "active",
  CURRENCY_BTC: "btc",
  CURRENCY_ETH: "eth",
  CURRENCY_AMAL: "amal",
  CURRENCY_USDT: "usdt",
  CURRENCY_TOKEN: "erc20",

  MAIN_BALANCE: "Main Balance",
  DIVIDEND_NORMAL: "Dividend Balance",
  DIVIDEND_BY_ADMIN: "Dividend Perpetual Balance",
  FUNDING: "funding",
  TRADING: "trading",
  TYPE_EXCHANGE_BALANCE: "spot",
  TYPE_MARGIN_BALANCE: "margin",
  TYPE_MAIN_BALANCE: "main",
  TYPE_MAM_BALANCE: "mam",
  TYPE_AIRDROP_BALANCE: "airdrop",
  TYPE_DIVIDEND_BONUS_BALANCE: "dividend_bonus",
  BONUS_BALANCE_TRANSFER_STATUS: { 1: "pending", 2: "success", 3: "fail" },
};
